export class OtpRequestToken {
    public newPhone: string = '';
    public email: string = '';
    public companyCode:string='';
}